"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1346],{

/***/ 66621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StarsComponent; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/ExpandMore.esm.js + 1 modules
var ExpandMore_esm = __webpack_require__(39591);
// EXTERNAL MODULE: ./components/profiles/Reviews/ReviewStatisticRow.tsx
var ReviewStatisticRow = __webpack_require__(26800);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/default.tsx





var Default = function(param) {
    var expanded = param.expanded, averageRating = param.averageRating, review = param.review, toggleExpandedContent = param.toggleExpandedContent;
    var theme = (0,useTheme_esm/* default */.Z)();
    var isLessThenLg = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("lg"));
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        pb: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                display: "flex",
                sx: {
                    px: {
                        lg: 2,
                        xs: 0
                    },
                    mt: 1,
                    mb: expanded ? 0 : 1
                },
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                        value: averageRating,
                        sx: {
                            fontSize: 24
                        },
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore_esm/* default */.Z, {
                        sx: !expanded ? {
                            transform: "rotate(180deg)"
                        } : {},
                        fontSize: "inherit",
                        onClick: toggleExpandedContent
                    })
                ]
            }),
            !expanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.overallExperience,
                        name: translate("reviews.overallExperience"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.bedsideManner,
                        name: translate("reviews.bedsideManner"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.explanation,
                        name: translate("reviews.explanation"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.cleanliness,
                        name: translate("reviews.cleanliness"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.friendliness,
                        name: translate("reviews.friendliness"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.waitTime,
                        name: translate("reviews.wait_time"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.facilities,
                        name: translate("reviews.facilities"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.careAndSupport,
                        name: translate("reviews.careAndSupport"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.ease,
                        name: translate("reviews.easy"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.quality,
                        name: translate("reviews.quality"),
                        noSpaceBefore: isLessThenLg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewStatisticRow/* default */.Z, {
                        rating: review === null || review === void 0 ? void 0 : review.impact,
                        name: translate("reviews.impact"),
                        noSpaceBefore: isLessThenLg
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StarsComponent_default = (Default);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/minimal.tsx





var Minimal = function(param) {
    var averageRating = param.averageRating, review = param.review, toggleExpandedContent = param.toggleExpandedContent;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var formattedReviewText = (0,react.useMemo)(function() {
        var isGermany = locale.includes("de");
        var reviewText = translate("reviews.reviews");
        return isGermany ? reviewText : reviewText.toLowerCase();
    }, [
        locale,
        translate
    ]);
    var href = "#reviews";
    var color = "#051851";
    var formatRating = averageRating === 0 ? "-" : averageRating;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
        sx: {
            textDecoration: "none"
        },
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
            display: "flex",
            gap: "5px",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    sx: {
                        fontSize: "24px",
                        fontWeight: 500,
                        color: color
                    },
                    children: formatRating
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                    sx: {
                        fontSize: "13px",
                        fontWeight: 500,
                        color: color,
                        paddingTop: "4px"
                    },
                    children: "/5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* default */.Z, {
                    value: averageRating,
                    sx: {
                        fontSize: 24
                    },
                    size: "low-medium",
                    readOnly: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link_esm/* default */.Z, {
                    component: "span",
                    sx: {
                        color: color
                    },
                    href: href,
                    onClick: toggleExpandedContent,
                    children: [
                        "(",
                        (ref = review === null || review === void 0 ? void 0 : review.reviewsTotal) !== null && ref !== void 0 ? ref : 0,
                        " ",
                        formattedReviewText,
                        ")"
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var minimal = (Minimal);

// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/types.ts
var types = __webpack_require__(42038);
;// CONCATENATED MODULE: ./components/RatingBar/components/StarsComponent/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var StarsComponent = function(_param) {
    var variant = _param.variant, props = _objectWithoutProperties(_param, [
        "variant"
    ]);
    if (variant === types/* Variants.minimal */.t.minimal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent_default, _objectSpread({}, props));
};
/* harmony default export */ var components_StarsComponent = (StarsComponent);


/***/ }),

/***/ 42038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Variants; }
/* harmony export */ });
var Variants;
(function(Variants) {
    Variants[Variants["default"] = 0] = "default";
    Variants[Variants["minimal"] = 1] = "minimal";
})(Variants || (Variants = {}));


/***/ }),

/***/ 47071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Variants; },
  "Z": function() { return /* binding */ components_Avatar; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(90884);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/PlayCircle/index.esm.js
var index_esm = __webpack_require__(58568);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(90427);
// EXTERNAL MODULE: ./utils/getImageWithWWW.ts
var getImageWithWWW = __webpack_require__(62400);
// EXTERNAL MODULE: ./components/profiles/Intro/variants/default/index.tsx + 1 modules
var variants_default = __webpack_require__(32930);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
;// CONCATENATED MODULE: ./components/profiles/Intro/components/Avatar/styles.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var AvatarContainerVariant1 = (0,styled_esm/* default */.ZP)(styles/* StyledAvatarContainer */.yJ)({});
var AvatarContainerVariant2 = (0,styled_esm/* default */.ZP)(styles/* StyledAvatarContainer */.yJ)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderRadius: "8px",
        width: "217px",
        height: "217px"
    }, theme.breakpoints.down("sm"), {
        width: "97px",
        height: "97px"
    });
});
var AvatarVariant1 = (0,styled_esm/* default */.ZP)(styles/* StyledAvatar */.bw)({});
var AvatarVariant2 = (0,styled_esm/* default */.ZP)(styles/* StyledAvatar */.bw)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        borderRadius: "8px",
        border: "solid thin #BFCDF6",
        width: "217px",
        height: "217px",
        backgroundColor: "#FFFFFF !important"
    }, theme.breakpoints.down("sm"), {
        width: "97px",
        height: "97px"
    });
});
var TypographyAvatarVariant1 = (0,styled_esm/* default */.ZP)(styles/* StyledTypographyAvatar */.Rq)({});
var TypographyAvatarVariant2 = (0,styled_esm/* default */.ZP)(styles/* StyledTypographyAvatar */.Rq)({
    fontFamily: "ES Klarheit Kurrent",
    fontWeight: 200,
    color: "#1A3586"
});

;// CONCATENATED MODULE: ./components/profiles/Intro/components/Avatar/index.tsx
function Avatar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var Variants;
(function(Variants) {
    Variants["VARIANT1"] = "variant1";
    Variants["VARIANT2"] = "variant2";
})(Variants || (Variants = {}));
var useAvatarConfig = function() {
    var variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Variants.VARIANT1;
    var variant1 = {
        Avatar: AvatarVariant1,
        AvatarContainer: AvatarContainerVariant1,
        TypographyAvatar: TypographyAvatarVariant1,
        PlayVideoButton: styles/* StyledPlayVideoButton */.O0
    };
    switch(variant){
        case Variants.VARIANT1:
            {
                return variant1;
            }
        case Variants.VARIANT2:
            {
                return {
                    Avatar: AvatarVariant2,
                    AvatarContainer: AvatarContainerVariant2,
                    TypographyAvatar: TypographyAvatarVariant2,
                    PlayVideoButton: (0,styled_esm/* default */.ZP)(styles/* StyledPlayVideoButton */.O0)(function(param) {
                        var theme = param.theme;
                        return Avatar_defineProperty({}, theme.breakpoints.down("sm"), {
                            "&>svg": {
                                margin: "-12px"
                            }
                        });
                    })
                };
            }
        default:
            {
                return variant1;
            }
    }
};
var Avatar = function(param) {
    var variant = param.variant, isEntryOrUnclaimed = param.isEntryOrUnclaimed, handleOpenVideoPlayer = param.handleOpenVideoPlayer, title = param.title, id = param.id, image = param.image, name = param.name, introVideoAvailable = param.introVideoAvailable;
    var ref, ref1;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var imageWithWWW = (0,getImageWithWWW/* default */.Z)(image);
    var initials = (0,variants_default/* getInitialsFromFullName */.u)(name);
    var ref2 = useAvatarConfig(variant), Avatar1 = ref2.Avatar, AvatarContainer = ref2.AvatarContainer, TypographyAvatar = ref2.TypographyAvatar, PlayVideoButton = ref2.PlayVideoButton;
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
            item: true,
            maxHeight: "min-content",
            position: "relative",
            mr: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                    onClick: handleOpenVideoPlayer,
                    variant: "ghost",
                    sx: {
                        padding: 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar1, {
                        width: 104,
                        height: 104,
                        alt: title || "",
                        src: !isEntryOrUnclaimed ? imageWithWWW : "",
                        preload: true,
                        sx: {
                            backgroundColor: !isEntryOrUnclaimed && image ? "transparent" : "blue.200"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyAvatar, {
                            children: initials
                        })
                    })
                }),
                introVideoAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayVideoButton, {
                    "aria-label": translate("media_center.introduction_video"),
                    variant: "ghost",
                    onClick: handleOpenVideoPlayer,
                    id: id,
                    "data-testid": constants/* TEST_IDS.PROFILE_INTRO_VIDEO_BUTTON */.z7.PROFILE_INTRO_VIDEO_BUTTON,
                    sx: (ref3 = theme === null || theme === void 0 ? void 0 : (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SearchProfileCard) === null || ref1 === void 0 ? void 0 : ref1.profileAvatarContainer) !== null && ref3 !== void 0 ? ref3 : {},
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* PlayCircleIcon */.z, {
                        sx: {
                            width: "35px",
                            height: "35px"
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_Avatar = (Avatar);


/***/ }),

/***/ 51609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Intro; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(48189);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
// EXTERNAL MODULE: ./components/profiles/Intro/variants/default/index.tsx + 1 modules
var variants_default = __webpack_require__(32930);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/utils/formatters.esm.js
var formatters_esm = __webpack_require__(82708);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/UnverifiedCurved/index.esm.js



const UnverifiedCurvedIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: 17, height: 17, viewBox: "0 0 17 17" }, props),
    react.createElement("path", { d: "M7.36869 2.14454C7.76885 1.6168 8.56221 1.6168 8.96236 2.14454L9.37993 2.69524C9.81661 3.27114 10.53 3.56664 11.246 3.4682L11.9307 3.37406C12.5868 3.28385 13.1478 3.84484 13.0576 4.50095L12.9634 5.18562C12.865 5.90162 13.1605 6.61503 13.7364 7.05171L14.2871 7.46928C14.8148 7.86943 14.8148 8.66279 14.2871 9.06295L13.7364 9.48052C13.1605 9.91719 12.865 10.6306 12.9634 11.3466L13.0576 12.0313C13.1478 12.6874 12.5868 13.2484 11.9307 13.1582L11.246 13.064C10.53 12.9656 9.81661 13.2611 9.37993 13.837L8.96236 14.3877C8.56221 14.9154 7.76885 14.9154 7.36869 14.3877L6.95113 13.837C6.51445 13.2611 5.80104 12.9656 5.08503 13.064L4.40037 13.1582L4.46847 13.6535L4.40037 13.1582C3.74425 13.2484 3.18326 12.6874 3.27347 12.0313L3.36761 11.3466C3.46606 10.6306 3.17055 9.91719 2.59465 9.48052L2.04395 9.06295C1.51622 8.66279 1.51622 7.86943 2.04395 7.46928L2.59465 7.05171C3.17055 6.61503 3.46606 5.90162 3.36761 5.18562L3.27347 4.50095C3.18326 3.84483 3.74425 3.28385 4.40036 3.37406L5.08503 3.4682C5.80103 3.56664 6.51445 3.27114 6.95113 2.69524L7.36869 2.14454Z", stroke: "#CC4F4A", fill: "#CC4F4A" }),
    react.createElement("path", { d: "M5.6864 5.809L10.6445 10.7232", stroke: "#FFFFFF", strokeWidth: "1.4", strokeLinecap: "round" }),
    react.createElement("path", { d: "M10.6227 5.78705L5.70842 10.7452", stroke: "#FFFFFF", strokeWidth: "1.4", strokeLinecap: "round" })));



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/VerifiedCurved/index.esm.js



const VerifiedCurvedIcon = (props) => (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ width: 16, height: 17, viewBox: "0 0 18 22" }, props),
    react.createElement("path", { d: "M6.80475 2.07632C7.40498 1.28472 8.59502 1.28472 9.19525 2.07632L9.61282 2.62702C9.94033 3.05895 10.4754 3.28058 11.0124 3.20674L11.6971 3.11261C12.6812 2.97729 13.5227 3.81877 13.3874 4.80294L13.2933 5.48761C13.2194 6.02461 13.4411 6.55967 13.873 6.88718L14.4237 7.30475C15.2153 7.90498 15.2153 9.09502 14.4237 9.69525L13.873 10.1128C13.4411 10.4403 13.2194 10.9754 13.2933 11.5124L13.3874 12.1971C13.5227 13.1812 12.6812 14.0227 11.6971 13.8874L11.0124 13.7933C10.4754 13.7194 9.94033 13.9411 9.61282 14.373L9.19525 14.9237C8.59502 15.7153 7.40498 15.7153 6.80475 14.9237L6.38718 14.373C6.05967 13.9411 5.52461 13.7194 4.98761 13.7933L4.30294 13.8874C3.31877 14.0227 2.47729 13.1812 2.61261 12.1971L2.70674 11.5124C2.78058 10.9754 2.55895 10.4403 2.12702 10.1128L1.57632 9.69525C0.784723 9.09502 0.784722 7.90498 1.57632 7.30475L2.12702 6.88718C2.55895 6.55967 2.78058 6.02461 2.70674 5.48761L2.61261 4.80294C2.47729 3.81877 3.31877 2.97729 4.30294 3.11261L4.98761 3.20674C5.52461 3.28058 6.05967 3.05895 6.38718 2.62702L6.80475 2.07632Z", fill: "#1A3586" }),
    react.createElement("path", { d: "M5.22339 8.90816L6.80139 10.4862L10.774 6.51367", stroke: "white", strokeWidth: "1.2", strokeLinecap: "round" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(46311);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(16062);
// EXTERNAL MODULE: ./utils/address.ts
var utils_address = __webpack_require__(93953);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(90884);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(90427);
// EXTERNAL MODULE: ./components/profiles/Intro/components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(47071);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
;// CONCATENATED MODULE: ./components/profiles/Intro/components/ProfileDetails.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






var textColor = "#11245A";
var Label = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: textColor,
        fontSize: "13px",
        weight: 400
    };
});
var HorizontalDelimiter = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    width: "3.48px",
    height: "3.48px",
    backgroundColor: textColor,
    display: "inline-flex",
    borderRadius: "50%",
    margin: "2px 8px"
});
var InfoPoint = function(param) {
    var icon = param.icon, label = param.label, skipIcons = param.skipIcons, _sx = param.sx, sx = _sx === void 0 ? {} : _sx;
    var IconWrapper = skipIcons ? Hidden_esm/* default */.Z : react.Fragment;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        sx: _objectSpread({
            display: "flex",
            gap: "5px",
            alignItems: "center"
        }, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, _objectSpread({}, skipIcons ? {
                smDown: true
            } : {}, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        minWidth: "32px"
                    },
                    children: icon
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                children: label
            })
        ]
    });
};
var ProfileDetails = function(param) {
    var yearsOfExperience = param.yearsOfExperience, address = param.address, addressTotal = param.addressTotal, connections = param.connections, endorsementsFrom = param.endorsementsFrom, isBookingAvailable = param.isBookingAvailable, skipIcons = param.skipIcons, toggleBookingModal = param.toggleBookingModal, workingTime = param.workingTime, specialties = param.specialties, specialtiesTotal = param.specialtiesTotal, specialistsTotal = param.specialistsTotal, followers = param.followers;
    var isRtl = (0,react.useContext)(AppData/* AppDataContext */.R).isRtl;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        container: true,
        direction: "column",
        sx: {
            gap: "10px"
        },
        children: [
            isBookingAvailable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    onClick: toggleBookingModal,
                    sx: {
                        width: "12px",
                        height: "12px",
                        cursor: "pointer"
                    },
                    bgcolor: "#00BF7C",
                    borderRadius: "50%"
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    onClick: toggleBookingModal,
                    sx: {
                        textDecoration: "underline",
                        cursor: "pointer"
                    },
                    children: translate("profile.intro.live_bookings_available")
                })
            }) : null,
            yearsOfExperience ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 18 19",
                    sx: {
                        width: "16px",
                        height: "16px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#shield-man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: translate("years_experience", {
                        total: yearsOfExperience
                    })
                })
            }) : null,
            address ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 16 16",
                    sx: {
                        ml: 0,
                        width: "16px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        href: "#location-pin-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#locations",
                        children: addressTotal > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                    display: "inline",
                                    children: "".concat(address, " ")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                    display: "inline",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "("
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                cursor: "pointer",
                                                textDecoration: "underline"
                                            },
                                            children: translate("plus_count_more", {
                                                count: addressTotal - 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: ")"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                            sx: {
                                cursor: "pointer",
                                textDecoration: "underline"
                            },
                            display: "inline",
                            children: address
                        })
                    })
                })
            }) : null,
            connections ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 20 20",
                    sx: {
                        ml: 0,
                        width: "20px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: translate("connections_in_healthcare", {
                        total: connections
                    })
                })
            }) : null,
            endorsementsFrom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 37 25",
                    sx: {
                        width: "32px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#91A8D6",
                        href: "#endorsement-group-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#endorsements",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                display: "inline",
                                sx: {
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                },
                                children: translate("profile.intro.skill_endorsed")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            display: "inline",
                            children: [
                                " ",
                                endorsementsFrom
                            ]
                        })
                    ]
                })
            }) : null,
            workingTime ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 14 14",
                    sx: {
                        width: "16px",
                        height: "16px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#clock-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                    children: workingTime
                })
            }) : null,
            (specialties === null || specialties === void 0 ? void 0 : specialties.length) && specialtiesTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                sx: {
                    alignItems: "flex-start"
                },
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 19 19",
                    sx: {
                        ml: 0,
                        width: "22px",
                        height: "22px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#rosette-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    lineHeight: "22px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            display: "inline",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                                    display: "inline",
                                    children: [
                                        translate("profile.specialties"),
                                        ": "
                                    ]
                                }),
                                specialties.map(function(specialty, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                display: "inline",
                                                children: specialty
                                            }, key),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalDelimiter, {})
                                        ]
                                    });
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "#specialties",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                display: "inline",
                                sx: {
                                    cursor: "pointer",
                                    textDecoration: "underline"
                                },
                                children: translate("view_all", {
                                    count: specialtiesTotal
                                })
                            })
                        })
                    ]
                })
            }) : null,
            specialistsTotal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 16 16",
                    sx: {
                        ml: 0,
                        width: "18px",
                        height: "18px",
                        color: "transparent"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#users-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "#specialists",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            display: "inline",
                            sx: {
                                cursor: "pointer",
                                textDecoration: "underline"
                            },
                            children: [
                                specialistsTotal,
                                " ",
                                translate("specialists.disclaimer", {
                                    count: specialistsTotal
                                })
                            ]
                        })
                    })
                })
            }) : null,
            followers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPoint, {
                skipIcons: skipIcons,
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon_esm/* default */.Z, {
                    viewBox: "0 0 20 20",
                    sx: {
                        ml: 0,
                        width: "20px",
                        height: "20px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        stroke: textColor,
                        href: "#man-icon"
                    })
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                    isRtl: isRtl,
                    sx: {
                        "& .MuiTooltip-tooltip": {
                            height: "auto",
                            width: "auto"
                        }
                    },
                    title: translate("healthcare_followers.disclaimer", {
                        count: followers
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            children: [
                                followers,
                                " ",
                                translate("healthcare_followers", {
                                    count: followers
                                })
                            ]
                        })
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var components_ProfileDetails = (ProfileDetails);

// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/index.tsx + 2 modules
var StarsComponent = __webpack_require__(66621);
// EXTERNAL MODULE: ./components/RatingBar/components/StarsComponent/types.ts
var types = __webpack_require__(42038);
;// CONCATENATED MODULE: ./components/profiles/Intro/variants/minimal/index.tsx
function minimal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function minimal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            minimal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function Minimal(param) {
    var name = param.name, suffix = param.suffix, title = param.title, image = param.image, keywords = param.keywords, yearsOfExperience = param.yearsOfExperience, address = param.address, isClinic = param.isPractice, practices = param.practices, _isUnclaimed = param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _isEntry = param.isEntry, isEntry = _isEntry === void 0 ? false : _isEntry, _introVideoAvailable = param.introVideoAvailable, introVideoAvailable = _introVideoAvailable === void 0 ? false : _introVideoAvailable, _setVideoPlayerVisibility = param.setVideoPlayerVisibility, setVideoPlayerVisibility = _setVideoPlayerVisibility === void 0 ? function() {
        return null;
    } : _setVideoPlayerVisibility, profileAnalytics = param.profileAnalytics, _connectionsCount = param.connectionsCount, connectionsCount = _connectionsCount === void 0 ? 0 : _connectionsCount, isBookingAvailable = param.isBookingAvailable, review = param.review, recommendersString = param.recommendersString, workingTimeString = param.workingTimeString, specialtiesList = param.specialtiesList, _specialtiesCount = param.specialtiesCount, specialtiesCount = _specialtiesCount === void 0 ? 0 : _specialtiesCount, _specialistsCount = param.specialistsCount, specialistsCount = _specialistsCount === void 0 ? 0 : _specialistsCount, _followersCount = param.followersCount, followersCount = _followersCount === void 0 ? 0 : _followersCount, toggleBookingModal = param.toggleBookingModal, hideRating = param.hideRating;
    var ref5;
    var theme = (0,useTheme_esm/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref1 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref1.language, locale = ref1.locale, isRtl = ref1.isRtl;
    var formattedConnectionsCount = (0,react.useMemo)(function() {
        return isClinic ? (0,formatters_esm/* formatNumberWithPlus */.Y)(connectionsCount) : connectionsCount;
    }, [
        isClinic,
        connectionsCount
    ]);
    var isBasicView = isEntry || isUnclaimed;
    var userTitle = (0,react.useMemo)(function() {
        var ut = name;
        if (title) {
            ut = "".concat(title, " ").concat(ut);
        }
        return ut;
    }, [
        name,
        title
    ]);
    var topLevelKeywords = (0,useKeywordsMapper/* useTopLevelKeywords */.F)(keywords || []);
    var yearsOfExperienceValue = (0,react.useMemo)(function() {
        return (0,date/* getYearsDiff */.qW)(yearsOfExperience || "");
    }, [
        yearsOfExperience
    ]);
    var defaultCountry = (0,global/* getDefaultCountry */.qH)(locale);
    var ref2 = (0,react.useMemo)(function() {
        var ref, ref4;
        var addressToTransform = address || (0,utils_address/* getAddressFromPractices */.zz)(practices);
        if (!addressToTransform) {
            return {
                address: defaultCountry,
                total: 0
            };
        }
        return address ? {
            address: (0,utils_address/* transformAddressToString */.CU)(addressToTransform, language) || defaultCountry,
            total: 1
        } : {
            address: (0,utils_address/* transformAddressToShortString */.c5)(addressToTransform, language) || defaultCountry,
            total: (practices === null || practices === void 0 ? void 0 : (ref = practices.filter) === null || ref === void 0 ? void 0 : (ref4 = ref.call(practices, utils_address/* removeVideoConsultation */.WM)) === null || ref4 === void 0 ? void 0 : ref4.length) || 1
        };
    }, [
        address,
        practices,
        language,
        defaultCountry
    ]), transformedAddress = ref2.address, addressTotal = ref2.total;
    var handleOpenVideoPlayer = (0,react.useCallback)(function() {
        if (introVideoAvailable) {
            if (window) {
                window.dataLayer.push(minimal_objectSpread({
                    event: "prf_pg_prf_vid_click",
                    cont_prf_name: userTitle
                }, profileAnalytics));
            }
            setVideoPlayerVisibility(true);
        }
    }, [
        introVideoAvailable,
        profileAnalytics,
        setVideoPlayerVisibility,
        userTitle
    ]);
    var onToggleBookingModal = (0,react.useCallback)(function() {
        toggleBookingModal === null || toggleBookingModal === void 0 ? void 0 : toggleBookingModal("book");
        if (!isClinic) {
            var ref, ref6, ref7;
            window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : (ref7 = ref.push) === null || ref7 === void 0 ? void 0 : ref7.call(ref, {
                event: "prf_pg_cont_button",
                cont_prf_name: name,
                cont_prf_type: "Specialist",
                cont_interaction_label: "live booking available",
                cont_prf_uuid: profileAnalytics === null || profileAnalytics === void 0 ? void 0 : (ref6 = profileAnalytics.profile) === null || ref6 === void 0 ? void 0 : ref6.prf_uuid
            });
        }
    }, [
        isClinic,
        name,
        profileAnalytics === null || profileAnalytics === void 0 ? void 0 : (ref5 = profileAnalytics.profile) === null || ref5 === void 0 ? void 0 : ref5.prf_uuid,
        toggleBookingModal
    ]);
    var displayTopKeyword = !isClinic && !!topLevelKeywords;
    var detailsSpecialistContent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                marginTop: "14px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfileDetails, {
                yearsOfExperience: isClinic ? null : yearsOfExperienceValue,
                address: transformedAddress,
                addressTotal: addressTotal,
                connections: isClinic ? null : formattedConnectionsCount,
                endorsementsFrom: isClinic ? null : recommendersString,
                isBookingAvailable: !isClinic && isBookingAvailable,
                toggleBookingModal: onToggleBookingModal
            })
        });
    }, [
        addressTotal,
        formattedConnectionsCount,
        isBookingAvailable,
        isClinic,
        onToggleBookingModal,
        recommendersString,
        transformedAddress,
        yearsOfExperienceValue
    ]);
    var detailsPracticeContent = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                marginTop: "10px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfileDetails, {
                address: transformedAddress,
                addressTotal: addressTotal,
                workingTime: workingTimeString,
                specialties: specialtiesList,
                specialtiesTotal: specialtiesCount,
                specialistsTotal: specialistsCount,
                followers: followersCount
            })
        });
    }, [
        addressTotal,
        followersCount,
        specialistsCount,
        specialtiesCount,
        specialtiesList,
        transformedAddress,
        workingTimeString
    ]);
    var mainFontColor = "#051851";
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                alignItems: "center",
                wrap: "nowrap",
                sx: {
                    pb: {
                        xs: hideRating ? "22px" : "8px",
                        sm: "32px"
                    },
                    gap: {
                        sm: "20px",
                        xs: "10px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        handleOpenVideoPlayer: handleOpenVideoPlayer,
                        introVideoAvailable: introVideoAvailable,
                        isEntryOrUnclaimed: isBasicView,
                        id: "IntroAvatar",
                        name: name,
                        image: image,
                        title: userTitle,
                        variant: Avatar/* Variants.VARIANT2 */.t.VARIANT2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        xs: 7.4,
                        direction: "column",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "h2",
                                component: "h1",
                                sx: {
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    color: mainFontColor,
                                    display: "flex",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                    gap: "3px",
                                    lineHeight: "20px",
                                    marginRight: "3px"
                                },
                                "data-testid": constants/* TEST_IDS.PROFILE_INTRO_AVATAR */.z7.PROFILE_INTRO_AVATAR,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                lineHeight: "32.04px",
                                                marginRight: "3px"
                                            },
                                            children: userTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                            display: "inline-block",
                                            children: [
                                                isUnclaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                                                    isRtl: isRtl,
                                                    sx: {
                                                        "& .MuiTooltip-tooltip": {
                                                            height: "auto",
                                                            width: "auto"
                                                        }
                                                    },
                                                    title: translate("profile.unverified"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                        display: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnverifiedCurvedIcon, {
                                                            sx: {
                                                                display: "inline-block",
                                                                verticalAlign: "middle",
                                                                width: "18px",
                                                                height: "18px",
                                                                marginTop: {
                                                                    md: "-1px",
                                                                    xs: "3px"
                                                                },
                                                                marginRight: "3px"
                                                            }
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                                                    isRtl: isRtl,
                                                    sx: {
                                                        "& .MuiTooltip-tooltip": {
                                                            height: "auto",
                                                            width: "auto"
                                                        }
                                                    },
                                                    title: translate("profile.verified"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                        display: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifiedCurvedIcon, {
                                                            sx: {
                                                                display: "inline-block",
                                                                verticalAlign: "middle",
                                                                width: "20px",
                                                                height: "22px",
                                                                marginTop: {
                                                                    md: "4px",
                                                                    xs: "7px"
                                                                },
                                                                marginRight: "3px"
                                                            }
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                    component: Hidden_esm/* default */.Z,
                                                    smUp: true,
                                                    implementation: "css",
                                                    display: "contents",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        display: "inline",
                                                        sx: {
                                                            fontSize: "13px",
                                                            fontWeight: 500
                                                        },
                                                        color: mainFontColor,
                                                        children: suffix
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                    component: Hidden_esm/* default */.Z,
                                                    smDown: true,
                                                    implementation: "css",
                                                    display: "contents",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                        display: "inline",
                                                        sx: {
                                                            fontSize: "15px",
                                                            color: mainFontColor,
                                                            paddingTop: "4px"
                                                        },
                                                        children: suffix
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            displayTopKeyword && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                sx: {
                                    mt: {
                                        sm: "6px"
                                    },
                                    fontSize: "18px",
                                    color: mainFontColor,
                                    lineHeight: "26px"
                                },
                                children: topLevelKeywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                sx: {
                                    marginLeft: "-8px"
                                },
                                children: isClinic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                    implementation: "css",
                                    smDown: true,
                                    children: detailsPracticeContent
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                    implementation: "css",
                                    smDown: true,
                                    children: detailsSpecialistContent
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                implementation: "css",
                smUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                    sx: {
                        pb: "14px"
                    },
                    children: [
                        hideRating ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                p: "10px",
                                borderTop: "1px solid ".concat(theme.palette.grey[600]),
                                borderBottom: "1px solid ".concat(theme.palette.grey[600]),
                                mt: "14px",
                                pb: "14px"
                            },
                            children: isBasicView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                                averageRating: 0,
                                review: null,
                                variant: types/* Variants.minimal */.t.minimal
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsComponent/* default */.Z, {
                                averageRating: (ref3 = review === null || review === void 0 ? void 0 : review.averageRating) !== null && ref3 !== void 0 ? ref3 : 0,
                                review: review,
                                variant: types/* Variants.minimal */.t.minimal
                            })
                        }),
                        isClinic ? detailsPracticeContent : detailsSpecialistContent
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var minimal = (Minimal);

;// CONCATENATED MODULE: ./components/profiles/Intro/index.tsx
function Intro_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Intro_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Intro_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function ProfileIntro(props) {
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var newPersistentPanelEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().newPersistentPanelEnabled;
    if (locale === global/* TENANTS.WPA */.rk.WPA) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_default/* default */.Z, Intro_objectSpread({}, props));
    }
    if (newPersistentPanelEnabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(minimal, Intro_objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(variants_default/* default */.Z, Intro_objectSpread({}, props));
}
/* harmony default export */ var Intro = (ProfileIntro);


/***/ }),

/***/ 32930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ variants_default; },
  "u": function() { return /* binding */ getInitialsFromFullName; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/MedicalServices/index.esm.js


const MedicalServicesIcon = (props) => (react.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    react.createElement("path", { d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z", fill: "#112971" }),
    react.createElement("path", { d: "M16.8741 8.73701H15.5351V7.31589C15.5351 6.29995 14.7335 5.47382 13.7148 5.47382H10.2855C9.26626 5.47382 8.46488 6.29995 8.46488 7.31589V8.73701H7.12561C6.213 8.73701 5.47362 9.44159 5.47362 10.3515V16.6078C5.47362 17.5174 6.213 18.2547 7.12561 18.2547H16.8741C17.7865 18.2547 18.5264 17.5174 18.5264 16.6076V10.3515C18.5264 9.44159 17.7865 8.73701 16.8741 8.73701ZM9.55261 7.31589C9.55261 6.93546 9.90394 6.56155 10.2855 6.56155H13.7148C14.0952 6.56155 14.4474 6.93546 14.4474 7.31589V8.73701H9.55261V7.31589ZM14.9913 14.7195H13.0877V16.6231H10.9123V14.7195H9.00874V12.5441H10.9123V10.6405H13.0877V12.5441H14.9913V14.7195Z", fill: "white" })));



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Tooltip/index.esm.js
var index_esm = __webpack_require__(63759);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/utils/formatters.esm.js
var formatters_esm = __webpack_require__(82708);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/Unverified/index.esm.js
var Unverified_index_esm = __webpack_require__(89165);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ShiledMan/index.esm.js
var ShiledMan_index_esm = __webpack_require__(56200);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/CheckCircleOutline.esm.js
var CheckCircleOutline_esm = __webpack_require__(21270);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/ConnectionsBadge/index.esm.js
var ConnectionsBadge_index_esm = __webpack_require__(59733);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/Edit/index.esm.js
var Edit_index_esm = __webpack_require__(9430);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/LocationOn/index.esm.js
var LocationOn_index_esm = __webpack_require__(67227);
// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ./hooks/useKeywordsMapper.ts
var useKeywordsMapper = __webpack_require__(46311);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ./utils/date.ts
var date = __webpack_require__(16062);
// EXTERNAL MODULE: ./utils/cookie.ts
var cookie = __webpack_require__(48463);
// EXTERNAL MODULE: ./utils/address.ts
var utils_address = __webpack_require__(93953);
// EXTERNAL MODULE: ./constants/profile.ts
var profile = __webpack_require__(50081);
// EXTERNAL MODULE: ./utils/getLanguageFromLocale.ts
var getLanguageFromLocale = __webpack_require__(90106);
// EXTERNAL MODULE: ./components/profiles/Intro/styles.ts
var styles = __webpack_require__(90884);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var profiles_styles = __webpack_require__(8971);
// EXTERNAL MODULE: ./components/Icons/FeeAgreedBadge.tsx
var FeeAgreedBadge = __webpack_require__(95817);
// EXTERNAL MODULE: ./components/Icons/FeeAgreedBadgeReversed.tsx
var FeeAgreedBadgeReversed = __webpack_require__(57615);
// EXTERNAL MODULE: ./hooks/useWpaTenant.ts
var useWpaTenant = __webpack_require__(68682);
// EXTERNAL MODULE: ./__tests__/testUtils/constants.ts
var constants = __webpack_require__(90427);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
// EXTERNAL MODULE: ./components/profiles/Intro/components/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(47071);
;// CONCATENATED MODULE: ./components/profiles/Intro/variants/default/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

// todo: refactor this file!



















var claimYourProfile = "claim-your-profile";
var Badge = function(param) {
    var icon = param.icon, title = param.title, color = param.color, testId = param.testId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* TextBox */.zC, {
        color: color || "common.white",
        height: "32px",
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                variant: "subtitle2",
                color: color || "system.navy",
                textTransform: "uppercase",
                lineHeight: "initial",
                ml: 1,
                mr: 2,
                my: 0.5,
                fontWeight: 500,
                display: "flex",
                component: "p",
                alignItems: "center",
                "data-testid": testId,
                children: title
            })
        ]
    });
};
var FeeAgreedTooltip = function(param) {
    var children = param.children;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
        title: translate("filter.fee-agreed.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                width: "fit-content"
            },
            children: children
        })
    });
};
var PremiumTooltip = function(param) {
    var children = param.children;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
        title: translate("filter.premium.description"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                width: "fit-content"
            },
            children: children
        })
    });
};
var getInitialsFromFullName = function(fullName) {
    var splittedName = fullName.split(" ");
    var firstName = splittedName[0];
    var lastName = splittedName[splittedName.length - 1];
    return firstName[0] + lastName[0];
};
// todo: move out if it's grow
var useComponentsConfig = function() {
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    return {
        displayVideoConsultationBadge: !isWPA
    };
};
// todo: fix complexity
// eslint-disable-next-line complexity
function Default(param) {
    var id = param.id, name = param.name, title = param.title, premium = param.premium, feeAgreed = param.feeAgreed, plan = param.plan, slug = param.slug, image = param.image, keywords = param.keywords, yearsOfExperience = param.yearsOfExperience, address = param.address, isClinic = param.isPractice, practices = param.practices, _isUnclaimed = param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, _isEntry = param.isEntry, isEntry = _isEntry === void 0 ? false : _isEntry, videoConsultation = param.videoConsultation, _introVideoAvailable = param.introVideoAvailable, introVideoAvailable = _introVideoAvailable === void 0 ? false : _introVideoAvailable, _setVideoPlayerVisibility = param.setVideoPlayerVisibility, setVideoPlayerVisibility = _setVideoPlayerVisibility === void 0 ? function() {
        return null;
    } : _setVideoPlayerVisibility, profileAnalytics = param.profileAnalytics, _connectionsCount = param.connectionsCount, connectionsCount = _connectionsCount === void 0 ? 0 : _connectionsCount;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref7 = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref7.language, locale = ref7.locale, isRtl = ref7.isRtl;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isWPA = (0,useWpaTenant/* useWpaTenant */.c)().isWPA;
    var isMobile = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.down("sm"));
    var formattedCount = (0,react.useMemo)(function() {
        return isClinic ? (0,formatters_esm/* formatNumberWithPlus */.Y)(connectionsCount) : connectionsCount;
    }, [
        isClinic,
        connectionsCount
    ]);
    var ref8 = (0,profiles_styles/* themedColor */.St)(), textColor = ref8.textColor, iconColor = ref8.iconColor;
    var isEntryOrUnclaimed = (0,react.useMemo)(function() {
        return isEntry || isUnclaimed;
    }, [
        isEntry,
        isUnclaimed
    ]);
    var displayVideoConsultationBadge = useComponentsConfig().displayVideoConsultationBadge;
    var defaultCountry = (0,global/* getDefaultCountry */.qH)(locale);
    var showTrustBadge = (0,react.useMemo)(function() {
        if (isWPA) {
            return false;
        }
        if (isClinic) {
            return connectionsCount >= profile/* CONNECTION_COUNT_TRUST_BADGE_PRACTICE */.D6;
        }
        return connectionsCount >= profile/* CONNECTION_COUNT_TRUST_BADGE_SPECIALIST */.w;
    }, [
        connectionsCount,
        isClinic,
        isWPA
    ]);
    var trustBadgeTooltipText = (0,react.useMemo)(function() {
        return translate("profile.intro.trustedNetwork.tooltip".concat(isClinic ? "-practice" : ""), {
            connectionsCount: String(formattedCount)
        });
    }, [
        formattedCount,
        isClinic,
        translate
    ]);
    var isMarketingEmail = ((ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_source) === "marketingemail";
    var CTAUrl = isMarketingEmail ? "/".concat(locale).concat(router.asPath.split("?")[0], "/").concat(locale === "de" || locale === "de-at" ? "beanspruchen-sie-ihr-profil" : claimYourProfile) : profile/* doctifyProviderDomain */.iJ + profile/* pathMap */.hn[locale] + profile/* endpoint */.FP;
    var topLevelKeywords = (0,useKeywordsMapper/* useTopLevelKeywords */.F)(keywords || []);
    var ref9 = (0,useKeywordsMapper/* useKeywordsMapper */._)(keywords || [], isClinic), specialties = ref9.specialties, subSpecialties = ref9.subSpecialties;
    var lang = (0,getLanguageFromLocale/* default */.Z)(locale);
    var userTitle = (0,react.useMemo)(function() {
        var ut = name;
        if (title) {
            ut = "".concat(title, " ").concat(ut);
        }
        return ut;
    }, [
        name,
        title
    ]);
    var yearsOfExperienceValue = (0,react.useMemo)(function() {
        return (0,date/* getYearsDiff */.qW)(yearsOfExperience || "");
    }, [
        yearsOfExperience
    ]);
    var transformedAddress = (0,react.useMemo)(function() {
        var addressToTransform = address || (0,utils_address/* getAddressFromPractices */.zz)(practices);
        if (!addressToTransform) {
            return "";
        }
        return address ? (0,utils_address/* transformAddressToString */.CU)(addressToTransform, language) : (0,utils_address/* transformAddressToShortString */.c5)(addressToTransform, language);
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        address,
        practices,
        isClinic
    ]);
    var profileVerifiedStatus = (0,react.useMemo)(function() {
        if (isUnclaimed) {
            return translate("unverivied_profile");
        }
        if (isWPA) {
            return isClinic ? translate("verified_practice") : translate("verified_practitioner");
        }
        return translate("verified_profile");
    }, [
        isClinic,
        isUnclaimed,
        isWPA,
        translate
    ]);
    var medicalServicesIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicalServicesIcon, {
        width: "32px",
        height: "32px"
    });
    var handleOpenVideoPlayer = function() {
        if (introVideoAvailable) {
            if (window) {
                window.dataLayer.push(_objectSpread({
                    event: "prf_pg_prf_vid_click",
                    cont_prf_name: userTitle
                }, profileAnalytics));
            }
            setVideoPlayerVisibility(true);
        }
    };
    var verifiedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
            xlinkHref: "#verified-circle-icon"
        })
    });
    var unverifiedIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
        borderRadius: 5,
        bgcolor: "system.coral200",
        p: 0.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Unverified_index_esm/* default */.Z, {
            sx: {
                height: 32,
                width: 32
            },
            color: "inherit",
            fill: "#051851"
        })
    });
    var renderBadges = function() {
        if (isWPA) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                smUp: true,
                implementation: "css",
                children: [
                    !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShiledMan_index_esm/* ShieldManIcon */.z, {
                                sx: {
                                    width: "16px",
                                    path: {
                                        stroke: theme.palette.common.white
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                color: textColor,
                                textTransform: "capitalize",
                                children: translate("years_of_experience", {
                                    years: yearsOfExperienceValue
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        gap: 1,
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline_esm/* default */.Z, {
                                sx: {
                                    width: "16px",
                                    path: {
                                        color: theme.palette.common.white
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                color: textColor,
                                textTransform: "capitalize",
                                children: profileVerifiedStatus
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            display: "flex",
            gap: 2,
            flexDirection: "row",
            wrap: "nowrap",
            children: [
                isUnclaimed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: unverifiedIcon,
                    title: translate("unverivied_profile")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: verifiedIcon,
                    testId: constants/* TEST_IDS.PROFILE_INTRO_VERIFIED */.z7.PROFILE_INTRO_VERIFIED,
                    title: translate("verified_profile")
                }),
                !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                    icon: medicalServicesIcon,
                    title: translate("years_of_experience", {
                        years: yearsOfExperienceValue
                    })
                })
            ]
        });
    };
    var ProfileDetails = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ProfileDetailsContainer */.oh, {
            container: true,
            direction: "column",
            sx: {
                pb: {
                    xs: "8px",
                    sm: 0
                }
            },
            children: [
                renderBadges(),
                showTrustBadge && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    gap: "6px",
                    my: "8px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* WhiteTooltip */.dp, {
                            isRtl: isRtl,
                            title: trustBadgeTooltipText,
                            componentsProps: {
                                tooltip: {
                                    sx: _objectSpread({}, isMobile ? {
                                        "&:before": {
                                            left: "12% !important"
                                        },
                                        "&:after": {
                                            left: "12% !important"
                                        }
                                    } : {}, {
                                        height: "auto !important",
                                        padding: "15px 10px !important"
                                    })
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectionsBadge_index_esm/* default */.Z, {
                                    withCheck: false,
                                    count: formattedCount,
                                    width: "16px",
                                    height: "16px"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            variant: "body2",
                            color: "text.darkNavy",
                            children: translate("profile.intro.trustedNetwork")
                        })
                    ]
                }),
                isClinic && isUnclaimed && !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                color: "primary.main",
                                variant: "body2",
                                children: translate("are_you_manager", {
                                    name: name,
                                    skipBold: true,
                                    defaultMessage: "Are you ".concat(name, " manager?")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_esm/* default */.Z, {
                            variant: "contained",
                            size: "small",
                            sx: {
                                mt: 1,
                                px: 1,
                                py: 0.5
                            },
                            href: CTAUrl,
                            onClick: function() {
                                return (0,cookie/* handleAddCookieCTA */.D)({
                                    id: id,
                                    slug: slug,
                                    type: plan
                                });
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    variant: "caption",
                                    mr: 1,
                                    fontWeight: 500,
                                    children: translate(isMarketingEmail ? claimYourProfile : "manage_your_profile")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Edit_index_esm/* default */.Z, {
                                    fontSize: "inherit"
                                })
                            ]
                        })
                    ]
                }),
                isUnclaimed && !isClinic && !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                        borderRadius: 1,
                        p: {
                            lg: theme.spacing(0.5, 1)
                        },
                        bgcolor: "common.white",
                        display: "inline-block",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "body2",
                                display: "inline",
                                mr: 2,
                                lineHeight: 2,
                                children: translate("are_you", {
                                    name: name
                                }, {
                                    bold: {
                                        fontWeight: 600
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                                variant: "contained",
                                sx: {
                                    padding: theme.spacing(0.5, 1.5)
                                },
                                href: CTAUrl,
                                onClick: function() {
                                    return (0,cookie/* handleAddCookieCTA */.D)({
                                        id: id,
                                        slug: slug,
                                        type: plan
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    color: "common.white",
                                    fontWeight: 500,
                                    variant: "caption",
                                    children: translate(isMarketingEmail ? claimYourProfile : "manage_your_profile")
                                })
                            })
                        ]
                    })
                }),
                !isClinic && videoConsultation && displayVideoConsultationBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "32",
                            height: "32",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                xlinkHref: "#video-cam-icon"
                            })
                        }),
                        title: "".concat(translate("video"), " ").concat(translate("consultation"))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                    smDown: true,
                    implementation: "css",
                    children: [
                        isClinic && premium && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTooltip, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                style: {
                                    width: "124px",
                                    height: "35px"
                                },
                                "data-testid": constants/* TEST_IDS.PREMIUM_BADGE */.z7.PREMIUM_BADGE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                    xlinkHref: "#premium-badge-lined-icon"
                                })
                            })
                        }),
                        !isClinic && feeAgreed && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadge/* default */.Z, {
                                "data-testid": constants/* TEST_IDS.FEE_AGREED_BADGE */.z7.FEE_AGREED_BADGE,
                                sx: {
                                    width: "100px",
                                    height: "30px"
                                }
                            })
                        })
                    ]
                })
            ]
        });
    };
    var ref10, ref11;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                container: true,
                wrap: "nowrap",
                sx: {
                    pb: {
                        xs: "8px",
                        sm: "32px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                handleOpenVideoPlayer: handleOpenVideoPlayer,
                                introVideoAvailable: introVideoAvailable,
                                isEntryOrUnclaimed: isEntryOrUnclaimed,
                                name: name,
                                id: "IntroAvatar",
                                image: image,
                                title: userTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smUp: true,
                                implementation: "css",
                                children: [
                                    isClinic && premium && isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(PremiumTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            style: _objectSpread({
                                                width: "124px",
                                                height: "35px"
                                            }, theme.custom.SearchProfileCard.mobileBadge),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                                                xlinkHref: "#premium-badge-lined-icon"
                                            })
                                        })
                                    }),
                                    !isClinic && feeAgreed && isWPA && (isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadgeReversed/* default */.Z, {
                                            sx: _objectSpread({
                                                width: "100px",
                                                height: "30px"
                                            }, (ref10 = theme === null || theme === void 0 ? void 0 : (ref1 = theme.custom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.SearchProfileCard) === null || ref2 === void 0 ? void 0 : ref2.mobileBadge) !== null && ref10 !== void 0 ? ref10 : {})
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedTooltip, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeeAgreedBadge/* default */.Z, {
                                            sx: _objectSpread({
                                                width: "125px",
                                                height: "35px"
                                            }, (ref11 = theme === null || theme === void 0 ? void 0 : (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SearchProfileCard) === null || ref4 === void 0 ? void 0 : ref4.mobileBadge) !== null && ref11 !== void 0 ? ref11 : {})
                                        })
                                    }))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                        container: true,
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                variant: "h2",
                                component: "h1",
                                sx: _objectSpread({
                                    color: "titleColor.color"
                                }, theme.custom.ProfileIntro.profileTitleTypography),
                                "data-testid": constants/* TEST_IDS.PROFILE_INTRO_AVATAR */.z7.PROFILE_INTRO_AVATAR,
                                children: userTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smDown: true,
                                children: [
                                    isWPA && !isClinic && !!topLevelKeywords ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                        color: textColor,
                                        children: topLevelKeywords
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        mt: 1,
                                        gap: theme.custom.SpecialistPage.detailsContainer.gap,
                                        sx: _defineProperty({
                                            alignItems: "center"
                                        }, theme.breakpoints.down("sm"), {
                                            alignItems: "start",
                                            flexDirection: "column"
                                        }),
                                        children: [
                                            !isWPA && !isClinic && !!topLevelKeywords ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                color: textColor,
                                                children: topLevelKeywords
                                            }) : null,
                                            isClinic && !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                gap: "12px",
                                                sx: {
                                                    pt: {
                                                        xs: 2
                                                    },
                                                    pl: {
                                                        xs: 2.5
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        variant: "subtitle1",
                                                        fontWeight: 500,
                                                        children: (ref5 = specialties[0]) === null || ref5 === void 0 ? void 0 : ref5.name[lang]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                                        sx: {
                                                            fontSize: "10.53px",
                                                            fontWeight: 500,
                                                            lineHeight: "15.795px",
                                                            color: "text.dark",
                                                            padding: "1px 6px",
                                                            span: {
                                                                padding: 0
                                                            }
                                                        },
                                                        label: "+".concat(subSpecialties.length),
                                                        variant: "blue"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                item: true,
                                                display: "flex",
                                                alignItems: "center",
                                                sx: _defineProperty({
                                                    wrap: "nowrap"
                                                }, theme.breakpoints.down("sm"), _objectSpread({}, !isClinic ? {
                                                    paddingTop: "0 !important"
                                                } : {})),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                                        smDown: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                            sx: {
                                                                ml: isWPA ? 0 : Number(!isClinic),
                                                                width: 16,
                                                                height: 16,
                                                                marginRight: "4px",
                                                                path: {
                                                                    fill: iconColor
                                                                }
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                                                        smUp: true,
                                                        children: isClinic && /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                            sx: {
                                                                width: 16,
                                                                height: 16,
                                                                marginRight: "4px",
                                                                path: {
                                                                    fill: iconColor
                                                                }
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                        color: textColor,
                                                        "data-testid": constants/* TEST_IDS.PROFILE_INTRO_LOCATION */.z7.PROFILE_INTRO_LOCATION,
                                                        textTransform: "capitalize",
                                                        children: transformedAddress || defaultCountry
                                                    })
                                                ]
                                            }),
                                            isWPA && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                                smDown: true,
                                                children: [
                                                    !isClinic && !!yearsOfExperienceValue && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        item: true,
                                                        gap: 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShiledMan_index_esm/* ShieldManIcon */.z, {
                                                                sx: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    fill: "none",
                                                                    path: {
                                                                        stroke: theme.palette.common.white
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                                color: textColor,
                                                                textTransform: "capitalize",
                                                                children: translate("years_of_experience", {
                                                                    years: yearsOfExperienceValue
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                        item: true,
                                                        gap: 1,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleOutline_esm/* default */.Z, {
                                                                sx: {
                                                                    width: 16,
                                                                    height: 16,
                                                                    path: {
                                                                        color: theme.palette.common.white
                                                                    }
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                                color: textColor,
                                                                textTransform: "capitalize",
                                                                children: profileVerifiedStatus
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden_esm/* default */.Z, {
                                smUp: true,
                                implementation: "css",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                        container: true,
                                        mt: 1,
                                        sx: _defineProperty({
                                            alignItems: "center"
                                        }, theme.breakpoints.down("sm"), {
                                            alignItems: "start",
                                            flexDirection: "column"
                                        }),
                                        children: [
                                            !isClinic && !!topLevelKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* TopKeywordText */.Zq, {
                                                color: textColor,
                                                children: topLevelKeywords
                                            }),
                                            isClinic && !!(subSpecialties === null || subSpecialties === void 0 ? void 0 : subSpecialties.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                gap: "12px",
                                                sx: {
                                                    pt: {
                                                        xs: 2
                                                    },
                                                    pl: {
                                                        xs: 2.5
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                                        variant: "subtitle1",
                                                        fontWeight: 500,
                                                        children: (ref6 = specialties[0]) === null || ref6 === void 0 ? void 0 : ref6.name[lang]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
                                                        sx: {
                                                            fontSize: "10.53px",
                                                            fontWeight: 500,
                                                            lineHeight: "15.795px",
                                                            color: "text.dark",
                                                            padding: "1px 6px",
                                                            span: {
                                                                padding: 0
                                                            }
                                                        },
                                                        label: "+".concat(subSpecialties.length),
                                                        variant: "blue"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                                                container: true,
                                                alignItems: "center",
                                                flexWrap: "nowrap",
                                                sx: _objectSpread({}, theme.custom.IntroSection, _defineProperty({}, theme.breakpoints.down("sm"), _objectSpread({}, !isClinic ? {
                                                    paddingTop: "0 !important"
                                                } : {}))),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn_index_esm/* default */.Z, {
                                                        sx: _objectSpread({}, theme.custom.LocationOnIcon, {
                                                            width: 16,
                                                            height: 16,
                                                            path: {
                                                                fill: iconColor
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* IntroTextInformation */.CL, {
                                                        color: textColor,
                                                        textTransform: "capitalize",
                                                        children: transformedAddress || defaultCountry
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                implementation: "css",
                smUp: true,
                children: !isWPA && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDetails, {})
            })
        ]
    });
}
/* harmony default export */ var variants_default = (Default);


/***/ }),

/***/ 56967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ profiles_ProfileTabs; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tab/Tab.esm.js + 1 modules
var Tab_esm = __webpack_require__(58341);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/styled.esm.js
var esm_styled_esm = __webpack_require__(64495);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Tabs/Tabs.esm.js + 8 modules
var Tabs_esm = __webpack_require__(92658);
;// CONCATENATED MODULE: ./hooks/usePageScrollProgress.ts

function usePageScrollProgress() {
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    (0,react.useEffect)(function() {
        var trackScroll = function() {
            var windowScroll = document.body.scrollTop || document.documentElement.scrollTop;
            var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            setProgress(windowScroll / scrollHeight * 100);
        };
        window.addEventListener("scroll", trackScroll, {
            passive: true
        });
        return function() {
            window.removeEventListener("scroll", trackScroll);
        };
    }, []);
    return progress;
};

// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
;// CONCATENATED MODULE: ./hooks/useActiveTabTracker.ts

function useActiveTabTracker(items) {
    var ref = (0,react.useState)(""), activeElement = ref[0], setActiveElement = ref[1];
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            items.some(function(item) {
                var target = document.querySelector("#".concat(item.selector));
                if (target) {
                    var rect = target.getBoundingClientRect();
                    if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
                        setActiveElement(item.selector);
                        return true;
                    }
                }
                return false;
            });
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        items
    ]);
    return activeElement;
};

// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./components/ContentTopContainer.tsx
var ContentTopContainer = __webpack_require__(18340);
// EXTERNAL MODULE: ./hooks/useVisibilityComponents.ts + 1 modules
var useVisibilityComponents = __webpack_require__(92422);
// EXTERNAL MODULE: ./components/Icons/ArrowRightIcon.tsx
var ArrowRightIcon = __webpack_require__(2730);
// EXTERNAL MODULE: ../../../node_modules/next/link.js
var next_link = __webpack_require__(89218);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/profiles/styles.ts
var styles = __webpack_require__(8971);
;// CONCATENATED MODULE: ./components/profiles/ProfileTabs.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var TabsRoot = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        width: "100%",
        backgroundColor: theme.palette.common.white,
        borderBottom: "1px solid ".concat(theme.palette.blue[200]),
        position: "sticky",
        top: 64,
        left: 0,
        marginTop: 0,
        zIndex: 999,
        overflowX: "auto",
        "& .MuiTab-root": {
            "&:after": {
                display: "none !important"
            }
        }
    }, theme.breakpoints.down("sm"), {
        top: 48,
        borderTop: "1px solid ".concat(theme.palette.blue[200])
    });
});
var LinkComponent = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "inline-block",
        color: theme.palette.text.darkNavy,
        padding: theme.custom.SpecialistPage.profileTab.padding,
        fontSize: 15,
        fontWeight: 400,
        opacity: 1,
        flexWrap: "nowrap",
        textDecoration: "none"
    }, _defineProperty(_obj, theme.breakpoints.down("md"), {
        fontSize: theme.typography.body2.fontSize
    }), _defineProperty(_obj, theme.breakpoints.up("md"), {
        "&:hover": {
            color: theme.palette.primary.main
        }
    }), _obj;
});
var StyledTab = (0,styled_esm/* default */.ZP)(Tab_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        padding: "0 !important",
        minWidth: "max-content",
        "&.Mui-active": {
            a: {
                color: "".concat(theme.palette.primary.dark, " !important"),
                fontWeight: 600,
                "&:after": {
                    // eslint-disable-next-line quotes
                    content: '""',
                    display: "block",
                    position: "absolute",
                    bottom: 0,
                    background: "",
                    width: "100%",
                    borderRadius: 4,
                    height: 4,
                    left: 0
                }
            }
        }
    };
});
var ScrollIndicator = (0,esm_styled_esm/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "width";
    }
})(function(param) {
    var width = param.width, theme = param.theme, color = param.color;
    return _defineProperty({
        position: "absolute",
        bottom: 0,
        left: 0,
        height: 4,
        width: "".concat(width, "%"),
        background: color,
        borderRadius: 4
    }, theme.breakpoints.down("sm"), {
        height: 1,
        background: color
    });
});
function ProfileTabs(_param) {
    var specialist = _param.specialist, practice = _param.practice, _isUnclaimed = _param.isUnclaimed, isUnclaimed = _isUnclaimed === void 0 ? false : _isUnclaimed, props1 = _objectWithoutProperties(_param, [
        "specialist",
        "practice",
        "isUnclaimed"
    ]);
    var theme = (0,useTheme_esm/* default */.Z)();
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var progressIndicatorColor = (0,styles/* themedColor */.St)().progressIndicatorColor;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var visibilityComponents = (0,useVisibilityComponents/* useVisibilityComponents */.c)({
        specialist: specialist,
        practice: practice
    });
    var tabs = (0,react.useMemo)(function() {
        var profileTabs = [];
        if (visibilityComponents.about) {
            profileTabs.push({
                label: translate("about"),
                selector: "about"
            });
        }
        if (specialist) {
            if (visibilityComponents.fees) {
                profileTabs.push({
                    label: translate("fees", {
                        defaultMessage: "Fees"
                    }),
                    selector: "fees"
                });
            }
            if (visibilityComponents.location) {
                profileTabs.push({
                    label: translate("locations"),
                    selector: "locations"
                });
            }
            if (visibilityComponents.reviews) {
                profileTabs.push({
                    label: translate("reviews.reviews"),
                    selector: "reviews"
                });
            }
            if (visibilityComponents.peerRecommendations) {
                profileTabs.push({
                    label: translate("skills"),
                    selector: "endorsements"
                });
            }
        }
        if (practice) {
            if (visibilityComponents.location) {
                profileTabs.push({
                    label: translate("locations"),
                    selector: "locations"
                });
            }
            if (visibilityComponents.reviews) {
                profileTabs.push({
                    label: translate("reviews.reviews"),
                    selector: "reviews"
                });
            }
            if (visibilityComponents.specialists) {
                profileTabs.push({
                    label: translate("specialists"),
                    selector: "specialists"
                });
            }
            if (visibilityComponents.facilities || visibilityComponents.services || visibilityComponents.parking) {
                profileTabs.push({
                    label: translate("facilities"),
                    selector: "services-facilities"
                });
            }
            if (visibilityComponents.gallery) {
                profileTabs.push({
                    label: translate("gallery"),
                    selector: "gallery"
                });
            }
        }
        if (visibilityComponents.videos || visibilityComponents.articles || visibilityComponents.media) {
            profileTabs.push({
                label: translate("media_center.media"),
                selector: "media"
            });
        }
        if (visibilityComponents.faq) {
            profileTabs.push({
                label: translate("faq"),
                selector: "faq"
            });
        }
        return profileTabs;
    // todo: clarify deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        specialist,
        isUnclaimed,
        practice
    ]);
    var trackingTabs = (0,react.useMemo)(function() {
        if (visibilityComponents.about) {
            return _toConsumableArray(tabs).concat([
                {
                    label: translate("about"),
                    selector: "about"
                }
            ]);
        }
        return tabs;
    }, [
        tabs,
        translate,
        visibilityComponents.about
    ]);
    var getTabIndex = (0,react.useCallback)(function(id) {
        if (tabs.findIndex(function(el) {
            return el.selector === id;
        }) === -1) {
            return false;
        }
        return tabs.findIndex(function(el) {
            return el.selector === id;
        });
    }, [
        tabs
    ]);
    var ref3 = (0,react.useState)(0), tabsValue = ref3[0], setTabsValue = ref3[1];
    var activeElement = useActiveTabTracker(trackingTabs);
    var slug = specialist && specialist.slug || practice && practice.slug;
    var isSpecialist = !!specialist;
    var scrollProgress = usePageScrollProgress();
    var onClick = function(tabLabel) {
        return function() {
            window.dataLayer.push({
                event: "prf_pg_navigaton",
                prf_navigation_label: tabLabel
            });
        };
    };
    var handleChangeSelectedTab = (0,react.useCallback)(function(_, ev) {
        return setTabsValue(+ev);
    }, []);
    (0,react.useEffect)(function() {
        var newTabIndex = getTabIndex(activeElement);
        if (newTabIndex) {
            setTabsValue(newTabIndex);
        }
    }, [
        activeElement,
        getTabIndex
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsRoot, _objectSpread({
        component: Hidden_esm/* default */.Z
    }, props1, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_esm/* default */.Z, {
                sx: {
                    marginTop: "0 !important",
                    backgroundColor: "transparent",
                    ".MuiTabs-indicator": {
                        display: "none"
                    },
                    "& .MuiTabs-scrollButtons": {
                        height: "34px",
                        width: "34px",
                        borderRadius: "50px",
                        border: "1px solid #D5DEF9",
                        backgroundColor: "transparent",
                        padding: "8px"
                    }
                },
                value: tabsValue,
                onChange: handleChangeSelectedTab,
                component: ContentTopContainer/* default */.Z,
                maxWidth: "xl",
                ScrollButtonComponent: function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightIcon/* default */.Z, _objectSpread({
                        directionLeft: props.direction === "left",
                        style: {
                            display: props.disabled ? "none" : "flex",
                            boxShadow: "".concat(props.direction === "left" ? "4px -4px" : "-4px 0px", " 10px 0px #D5DEF94D"),
                            backgroundColor: "white",
                            zIndex: 999
                        }
                    }, props));
                },
                variant: "scrollable",
                scrollButtons: "auto",
                allowScrollButtonsMobile: true,
                children: tabs.map(function(tab, index) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledTab, {
                        className: tab.selector === activeElement ? "Mui-active" : "",
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(locale, "/").concat(isSpecialist ? "specialist" : "practice", "/").concat(slug, "#").concat(tab.selector),
                            scroll: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComponent, {
                                sx: (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SpecialistPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.common) === null || ref2 === void 0 ? void 0 : ref2.tabBarItemHover,
                                children: tab.label
                            })
                        }),
                        value: getTabIndex(tab.selector),
                        onClick: onClick(tab.selector),
                        sx: {
                            paddingRight: index === tabs.length - 1 ? "24px" : "12px"
                        }
                    }, tab.selector);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollIndicator, {
                width: scrollProgress,
                color: progressIndicatorColor
            })
        ]
    }));
}
/* harmony default export */ var profiles_ProfileTabs = (ProfileTabs);


/***/ }),

/***/ 26800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98855);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75320);


var ReviewStatisticRow = function(param) {
    var rating = param.rating, name = param.name, _noSpaceBefore = param.noSpaceBefore, noSpaceBefore = _noSpaceBefore === void 0 ? false : _noSpaceBefore;
    if (!rating) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        sx: noSpaceBefore ? {
            pr: 2
        } : {
            px: 2
        },
        container: true,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                item: true,
                display: "flex",
                alignItems: "center",
                sx: {
                    mr: 3
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        readOnly: true,
                        value: rating,
                        sx: {
                            "& svg": {
                                width: 18,
                                height: 17
                            },
                            mr: 1
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        variant: "caption",
                        sx: {
                            m: 0
                        },
                        children: rating.toFixed(2)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                item: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    variant: "caption",
                    children: name
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewStatisticRow);


/***/ }),

/***/ 9883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64495);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36713);
/* harmony import */ var _ContentTopContainer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18340);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var SectionWrapperStyled = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("section", {
    shouldForwardProp: function(prop) {
        return prop !== "sx";
    }
})(function(param) {
    var sx = param.sx;
    return sx || {};
});
var SectionWrapper = function(param) {
    var sx = param.sx, children = param.children, id = param.id, ignoreContainer = param.ignoreContainer, _withPadding = param.withPadding, withPadding = _withPadding === void 0 ? false : _withPadding, containerRef = param.containerRef;
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionWrapperStyled, {
        ref: containerRef,
        sx: _objectSpread({
            py: withPadding ? theme.spacing(5) : undefined
        }, sx),
        id: id,
        children: ignoreContainer ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ContentTopContainer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            maxWidth: "xl",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionWrapper);


/***/ }),

/***/ 8971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dg": function() { return /* binding */ PublicationWrapper; },
/* harmony export */   "IW": function() { return /* binding */ StyledDivider; },
/* harmony export */   "Sn": function() { return /* binding */ StyledButton; },
/* harmony export */   "St": function() { return /* binding */ themedColor; },
/* harmony export */   "T0": function() { return /* binding */ StyledSpecialtiesWrapper; },
/* harmony export */   "aV": function() { return /* binding */ List; },
/* harmony export */   "f$": function() { return /* binding */ ItemWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "l2": function() { return /* binding */ StyledMenu; },
/* harmony export */   "wi": function() { return /* binding */ DayAvailabilityRoot; },
/* harmony export */   "xD": function() { return /* binding */ StyledSectionHeaderWrapper; }
/* harmony export */ });
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36713);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64495);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99611);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47992);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4595);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54597);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26025);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15819);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var textDarkNavy = "text.darkNavy";
// eslint-disable-next-line complexity
var themedColor = function() {
    var ref133, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98, ref99, ref100, ref101, ref102, ref103, ref104, ref105, ref106, ref107;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118, ref119, ref120, ref121, ref122, ref123, ref124, ref125, ref126, ref127, ref128, ref129, ref130, ref131, ref132;
    return {
        textColor: (ref108 = (ref133 = theme.custom) === null || ref133 === void 0 ? void 0 : (ref1 = ref133.SpecialistPage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.common) === null || ref2 === void 0 ? void 0 : ref2.color) !== null && ref108 !== void 0 ? ref108 : textDarkNavy,
        buttonBackground: "".concat((ref109 = (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SpecialistPage) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.common) === null || ref5 === void 0 ? void 0 : ref5.background) !== null && ref109 !== void 0 ? ref109 : "#2B59E0", " !important"),
        iconColor: (ref110 = (ref6 = theme.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.SpecialistPage) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.common) === null || ref8 === void 0 ? void 0 : ref8.color) !== null && ref110 !== void 0 ? ref110 : theme.palette.text.darkNavy,
        locationTitleColor: (ref111 = (ref9 = theme.custom) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.SpecialistPage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.common) === null || ref11 === void 0 ? void 0 : ref11.background) !== null && ref111 !== void 0 ? ref111 : "common.white",
        borderRadius: (ref112 = (ref12 = theme.custom) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.SpecialistPage) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.location) === null || ref14 === void 0 ? void 0 : ref14.containerBorderRadius) !== null && ref112 !== void 0 ? ref112 : "16px",
        chipsTextColor: (ref15 = theme.custom) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.SpecialistPage) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.common) === null || ref17 === void 0 ? void 0 : ref17.chipsTextColor,
        chipsBorder: (ref113 = (ref18 = theme.custom) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.SpecialistPage) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.common) === null || ref20 === void 0 ? void 0 : ref20.border) !== null && ref113 !== void 0 ? ref113 : "1px #2B59E0 solid",
        chipsBorderSelected: (ref114 = (ref21 = theme.custom) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.SpecialistPage) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.common) === null || ref23 === void 0 ? void 0 : ref23.borderSelected) !== null && ref114 !== void 0 ? ref114 : "1px #2B59E0 solid",
        showMoreChipsBackground: (ref115 = (ref24 = theme.custom) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.SpecialistPage) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.review) === null || ref26 === void 0 ? void 0 : ref26.showMoreChips) !== null && ref115 !== void 0 ? ref115 : "rgba(255, 99, 92, 0.2)",
        showMoreChipsColorOfText: (ref116 = (ref27 = theme.custom) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.SpecialistPage) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.review) === null || ref29 === void 0 ? void 0 : ref29.showMoreChipsColor) !== null && ref116 !== void 0 ? ref116 : "common.dark",
        checkboxColor: (ref117 = (ref30 = theme.custom) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.SpecialistPage) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.common) === null || ref32 === void 0 ? void 0 : ref32.background) !== null && ref117 !== void 0 ? ref117 : "#2B59E0",
        specialistLocationSectionBackground: (ref118 = (ref33 = theme.custom) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.SpecialistPage) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.location) === null || ref35 === void 0 ? void 0 : ref35.background) !== null && ref118 !== void 0 ? ref118 : "rgba(17, 41, 113, 0.8)",
        practiceLocationSectionBackground: (ref119 = (ref36 = theme.custom) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.SpecialistPage) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.location) === null || ref38 === void 0 ? void 0 : ref38.background) !== null && ref119 !== void 0 ? ref119 : "linear-gradient(0deg, #051851, #051851), #2C3341",
        endorsementsBackground: (ref120 = (ref39 = theme.custom) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.SpecialistPage) === null || ref40 === void 0 ? void 0 : (ref41 = ref40.endorsements) === null || ref41 === void 0 ? void 0 : ref41.background) !== null && ref120 !== void 0 ? ref120 : "background.light2",
        endorsementsChipsColor: (ref121 = (ref42 = theme.custom) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.SpecialistPage) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.endorsements) === null || ref44 === void 0 ? void 0 : ref44.chipsColor) !== null && ref121 !== void 0 ? ref121 : "rgba(0, 229, 208, 0.2)",
        endorsementsChipsBackground: (ref45 = theme.custom) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.SpecialistPage) === null || ref46 === void 0 ? void 0 : (ref47 = ref46.endorsements) === null || ref47 === void 0 ? void 0 : ref47.chipsBackground,
        endorsementsChipsBorder: (ref48 = theme.custom) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.SpecialistPage) === null || ref49 === void 0 ? void 0 : (ref50 = ref49.endorsements) === null || ref50 === void 0 ? void 0 : ref50.chipsBorder,
        endorsementsChipsSelectedBackground: (ref51 = theme.custom) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.SpecialistPage) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.endorsements) === null || ref53 === void 0 ? void 0 : ref53.chipsSelectedBackground,
        endorsementsChipsSelectedBorder: (ref54 = theme.custom) === null || ref54 === void 0 ? void 0 : (ref55 = ref54.SpecialistPage) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.endorsements) === null || ref56 === void 0 ? void 0 : ref56.chipsSelectedBorder,
        endorsementsChipsTextColor: (ref57 = theme.custom) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.SpecialistPage) === null || ref58 === void 0 ? void 0 : (ref59 = ref58.endorsements) === null || ref59 === void 0 ? void 0 : ref59.chipsTextColor,
        buttonBorder: (ref122 = (ref60 = theme.custom) === null || ref60 === void 0 ? void 0 : (ref61 = ref60.SpecialistPage) === null || ref61 === void 0 ? void 0 : (ref62 = ref61.common) === null || ref62 === void 0 ? void 0 : ref62.border) !== null && ref122 !== void 0 ? ref122 : "",
        focusButtonStyle: (ref123 = (ref63 = theme.custom) === null || ref63 === void 0 ? void 0 : (ref64 = ref63.SpecialistPage) === null || ref64 === void 0 ? void 0 : ref64.LoadMoreButton) !== null && ref123 !== void 0 ? ref123 : {},
        hoverButtonStyle: (ref124 = (ref65 = theme.custom) === null || ref65 === void 0 ? void 0 : (ref66 = ref65.SpecialistPage) === null || ref66 === void 0 ? void 0 : ref66.LoadMoreButtonHover) !== null && ref124 !== void 0 ? ref124 : {},
        buttonBorderRadius: (ref125 = (ref67 = theme.custom) === null || ref67 === void 0 ? void 0 : (ref68 = ref67.SpecialistPage) === null || ref68 === void 0 ? void 0 : (ref69 = ref68.common) === null || ref69 === void 0 ? void 0 : ref69.buttonBorderRadius) !== null && ref125 !== void 0 ? ref125 : "4px",
        titleTextTransform: (ref126 = (ref70 = theme.custom) === null || ref70 === void 0 ? void 0 : (ref71 = ref70.SpecialistPage) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.common) === null || ref72 === void 0 ? void 0 : ref72.titleTextTransform) !== null && ref126 !== void 0 ? ref126 : "uppercase",
        reviewTitleColor: (ref127 = (ref73 = theme.custom) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.SpecialistPage) === null || ref74 === void 0 ? void 0 : (ref75 = ref74.common) === null || ref75 === void 0 ? void 0 : ref75.titleColor) !== null && ref127 !== void 0 ? ref127 : textDarkNavy,
        linearProgressUnselected: (ref128 = (ref76 = theme.custom) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.SpecialistPage) === null || ref77 === void 0 ? void 0 : (ref78 = ref77.common) === null || ref78 === void 0 ? void 0 : ref78.background) !== null && ref128 !== void 0 ? ref128 : "#00E5D0",
        aboutSectionTitleColor: (ref79 = theme.custom) === null || ref79 === void 0 ? void 0 : (ref80 = ref79.SpecialistPage) === null || ref80 === void 0 ? void 0 : (ref81 = ref80.about) === null || ref81 === void 0 ? void 0 : ref81.titleColor,
        aboutSectionTitleFontWeight: (ref129 = (ref82 = theme.custom) === null || ref82 === void 0 ? void 0 : (ref83 = ref82.SpecialistPage) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.about) === null || ref84 === void 0 ? void 0 : ref84.fontWeight) !== null && ref129 !== void 0 ? ref129 : "600",
        progressIndicatorColor: (ref130 = (ref85 = theme.custom) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.SpecialistPage) === null || ref86 === void 0 ? void 0 : (ref87 = ref86.common) === null || ref87 === void 0 ? void 0 : ref87.progressIndicatorColor) !== null && ref130 !== void 0 ? ref130 : theme.palette.system.navy,
        reviewUnselectedTextColor: (ref131 = (ref88 = theme.custom) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.SpecialistPage) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.common) === null || ref90 === void 0 ? void 0 : ref90.color) !== null && ref131 !== void 0 ? ref131 : "common.white",
        chipBackground: (ref91 = theme.custom) === null || ref91 === void 0 ? void 0 : (ref92 = ref91.SpecialistPage) === null || ref92 === void 0 ? void 0 : (ref93 = ref92.common) === null || ref93 === void 0 ? void 0 : ref93.chipBackground,
        chipBorderColor: (ref94 = theme.custom) === null || ref94 === void 0 ? void 0 : (ref95 = ref94.SpecialistPage) === null || ref95 === void 0 ? void 0 : (ref96 = ref95.common) === null || ref96 === void 0 ? void 0 : ref96.chipBorderColor,
        reviewsChipBorder: (ref97 = theme.custom) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.SpecialistPage) === null || ref98 === void 0 ? void 0 : (ref99 = ref98.review) === null || ref99 === void 0 ? void 0 : ref99.chipsBorder,
        reviewsChipColor: (ref100 = theme.custom) === null || ref100 === void 0 ? void 0 : (ref101 = ref100.SpecialistPage) === null || ref101 === void 0 ? void 0 : (ref102 = ref101.review) === null || ref102 === void 0 ? void 0 : ref102.chipsTextColor,
        reviewsChipSelectedBackground: (ref103 = theme.custom) === null || ref103 === void 0 ? void 0 : (ref104 = ref103.SpecialistPage) === null || ref104 === void 0 ? void 0 : (ref105 = ref104.review) === null || ref105 === void 0 ? void 0 : ref105.chipsSelectedBackground,
        loadMoreButtonFocusStyle: (ref132 = (ref106 = theme.custom) === null || ref106 === void 0 ? void 0 : (ref107 = ref106.SpecialistPage) === null || ref107 === void 0 ? void 0 : ref107.LoadMoreButtonFocus) !== null && ref132 !== void 0 ? ref132 : {}
    };
};
var ref;
var StyledButton = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    shouldForwardProp: function(prop) {
        return prop !== "open";
    }
})(function(param) {
    var theme = param.theme, open = param.open;
    var ref140, ref134, ref135, ref136, ref137, ref138, ref139;
    return _objectSpread({}, theme.typography.body2, {
        background: "none",
        border: "1px solid transparent",
        fontWeight: "500",
        borderRadius: "16px",
        display: "flex",
        paddingLeft: "8px",
        paddingRight: "8px",
        height: "24px",
        alignItems: "center",
        cursor: "pointer",
        color: (ref140 = theme.custom) === null || ref140 === void 0 ? void 0 : ref140.SpecialistPage.review.showMoreTextColor,
        "&:hover": {
            border: "1px ".concat((ref = (ref134 = theme.custom) === null || ref134 === void 0 ? void 0 : (ref135 = ref134.SpecialistPage) === null || ref135 === void 0 ? void 0 : (ref136 = ref135.common) === null || ref136 === void 0 ? void 0 : ref136.background) !== null && ref !== void 0 ? ref : "transparent", " solid"),
            backgroundColor: (ref137 = theme.custom) === null || ref137 === void 0 ? void 0 : (ref138 = ref137.SpecialistPage) === null || ref138 === void 0 ? void 0 : (ref139 = ref138.review) === null || ref139 === void 0 ? void 0 : ref139.showMoreBackgroundHover
        },
        fontSize: "11.85px !important",
        "& svg": {
            transform: "rotate(".concat(open ? "180deg" : "0deg", ")")
        }
    });
});
var StyledMenu = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        "& .MuiMenu-paper ": {
            padding: theme.spacing(2),
            boxShadow: "0px 3px 4px rgba(2, 3, 3, 0.03), 0px 3px 3px rgba(2, 3, 3, 0.02), 0px 1px 8px rgba(2, 3, 3, 0.04)",
            borderRadius: 2,
            border: "1px solid ".concat(theme.palette.grey[600])
        },
        "& .MuiList-root ": {
            padding: theme.spacing(0),
            maxHeight: 300,
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": {
                width: 8,
                borderRadius: 8,
                background: "#D5DEF9"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.custom.scrollbarThumb.backgroundColor,
                borderRadius: 8
            }
        },
        "& .MuiButtonBase-root ": {
            minHeight: "24px"
        },
        "& .MuiMenuItem-root": {
            padding: theme.spacing(0),
            "&:hover": {
                backgroundColor: "initial"
            }
        }
    };
});
var ItemWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "spacing";
    }
})(function(param) {
    var theme = param.theme, spacing = param.spacing;
    return {
        display: "flex",
        alignItems: "center",
        maxWidth: "100%",
        margin: spacing === "small" ? theme.spacing(0.5) : theme.spacing(1, 2, 0, 0),
        "&:last-child": {
            marginRight: 0
        }
    };
});
var DayAvailabilityRoot = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        paddingBottom: theme.spacing(2),
        display: "flex",
        justifyContent: "space-between",
        "&:last-child": {
            paddingBottom: 0
        }
    };
});
var Wrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("lg"), {
        flexDirection: "column-reverse"
    });
});
var List = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul")(function(param) {
    var theme = param.theme;
    return _objectSpread({}, theme.typography.body1, {
        paddingLeft: 0,
        color: theme.palette.text.black900,
        textTransform: "capitalize"
    });
});
var StyledSectionHeaderWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        alignItems: "center",
        gap: "8px",
        width: "auto",
        flexWrap: "nowrap"
    }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
        alignItems: "flex-start"
    }), _defineProperty(_obj, "b", {
        fontWeight: 600
    }), _obj;
});
var StyledSpecialtiesWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("sm"), {
        flexDirection: "column",
        gap: "48px"
    });
});
var PublicationWrapper = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme, isFirst = param.isFirst, isLast = param.isLast;
    return {
        padding: "16px 0",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "transparent",
        borderBottomColor: isLast ? "transparent" : theme.palette.grey[600],
        borderTopColor: isFirst ? theme.palette.grey[600] : "transparent",
        marginBottom: "-1px",
        contentVisibility: "auto",
        containIntrinsicHeight: "500px",
        "&:hover": {
            backgroundColor: theme.palette.background.default,
            margin: "0 -8px -1px -8px",
            padding: "16px 8px",
            borderColor: "transparent",
            borderRadius: "8px"
        }
    };
});
var StyledDivider = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
    return {
        borderColor: "#D5DEF9",
        marginTop: 48,
        marginBottom: 48
    };
});


/***/ }),

/***/ 41654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHrefLang; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35837);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _providers_AppData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3426);



var useForLocales = [
    "en-ae",
    "ar-ae"
];
var useHrefLang = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_providers_AppData__WEBPACK_IMPORTED_MODULE_2__/* .AppDataContext */ .R).locale;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (useForLocales.includes(locale)) {
        return useForLocales.map(function(useForLocale) {
            return {
                rel: "alternate",
                href: "https://www.doctify.com/".concat(useForLocale).concat(router.asPath),
                hreflang: useForLocale
            };
        });
    }
    return undefined;
};


/***/ }),

/***/ 44945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GK": function() { return /* binding */ isHashString; },
/* harmony export */   "sJ": function() { return /* binding */ transformToHash; },
/* harmony export */   "sz": function() { return /* binding */ parseHashFromString; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var isHashString = function(path) {
    return path.includes("#") && path.includes("=");
};
var parseHashFromString = function(path) {
    if (!isHashString) {
        return {};
    }
    var hash = path.split("#")[1].replace(/\+/g, " ");
    var couples = hash.split("&").map(function(h) {
        return decodeURIComponent(h);
    });
    return couples.map(function(c) {
        return c.split("=");
    }).reduce(function(prev, param) {
        var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
        return v ? _objectSpread({}, prev, _defineProperty({}, k, v)) : prev;
    }, {});
};
var transformToHash = function(data) {
    var hashArray = [];
    Object.entries(data).forEach(function(param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        if (value && Array.isArray(value) && value.length) {
            value.forEach(function(item) {
                hashArray.push("".concat(encodeURIComponent(key), "[]=").concat(encodeURIComponent(String(item))));
            });
        } else if (value && !Array.isArray(value)) {
            hashArray.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(String(value))));
        }
    });
    return hashArray.join("&");
};



/***/ }),

/***/ 96900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ getHashFromString; },
/* harmony export */   "DD": function() { return /* binding */ tenantForChip; },
/* harmony export */   "ST": function() { return /* binding */ isActualFilters; },
/* harmony export */   "Uk": function() { return /* binding */ getRoundedReviewValue; }
/* harmony export */ });
/* harmony import */ var _hash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44945);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14257);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var getValidSort = function(sort) {
    if (sort === "desc" || sort === "asc" || sort === "bestRated" || sort === "worstRated" || sort === null) {
        return sort;
    }
    return "desc";
};
var getRoundedReviewValue = function(reviewValue) {
    var roundValue = 4 // 0.25
    ;
    if (!reviewValue || typeof reviewValue !== "number") {
        return 0;
    }
    return Math.floor(reviewValue * roundValue) / roundValue;
};
var getHashFromString = function(path) {
    var ref = (0,_hash__WEBPACK_IMPORTED_MODULE_1__/* .isHashString */ .GK)(path) ? (0,_hash__WEBPACK_IMPORTED_MODULE_1__/* .parseHashFromString */ .sz)(path) : {}, _sort = ref.sort, sort = _sort === void 0 ? "desc" : _sort, _keyword = ref.keyword, keyword = _keyword === void 0 ? "" : _keyword, _search = ref.search, search = _search === void 0 ? "" : _search;
    return {
        sort: getValidSort(sort),
        keyword: keyword,
        search: search
    };
};
var isActualFilters = function(routerFilters, filters) {
    var ref = typeof routerFilters === "string" ? getHashFromString(routerFilters) : routerFilters, sort = ref.sort, keyword = ref.keyword, search = ref.search;
    return sort === filters.sort && keyword === filters.keyword && search === filters.search;
};
var tenantForChip = function(tenant) {
    if (!tenant) {
        return null;
    }
    var objTenant = _defineProperty({}, _constants_global__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.AR_UAE */ .rk.AR_UAE, _constants_global__WEBPACK_IMPORTED_MODULE_0__/* .TENANTS.EN_UAE */ .rk.EN_UAE);
    var _tenant;
    return (_tenant = objTenant[tenant]) !== null && _tenant !== void 0 ? _tenant : tenant;
};



/***/ }),

/***/ 67657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ CheckCircleOutline; }
/* harmony export */ });
var CheckCircleOutline = {};




/***/ }),

/***/ 9430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Edit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const Edit = ({ color = 'white', fontSize }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { fontSize: fontSize, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 1H9V2H2V14H14V8H15V15H14H1V14V2V1ZM4 12V9.96306L10.0076 3.95546L12.0445 5.99239L6.03694 12H4ZM11.9631 2L14 4.03694L12.6257 5.41662L10.5888 3.37969L11.9631 2Z", fill: color })));




/***/ }),

/***/ 82708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ formatNumberWithPlus; }
/* harmony export */ });
const formatNumberWithPlus = (num) => {
    if (!num) {
        return undefined;
    }
    const rounded = Math.floor(num / 50) * 50;
    return `${rounded}+`;
};




/***/ })

}]);